// /**
//  * Stytch Headless Client Management
//  * Handles the creation and management of the Stytch B2B headless client
//  */
// import { createStytchB2BHeadlessClient } from '@stytch/nextjs/b2b/headless'
// // Create the Stytch client outside the component to avoid recreation
// let stytchClient: ReturnType<typeof createStytchB2BHeadlessClient> | null = null
// /**
//  * Get or create the Stytch client instance
//  */
// export function getStytchClient() {
//   if (!stytchClient && typeof window !== 'undefined') {
//     const publicToken = process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN
//     if (publicToken) {
//       try {
//         stytchClient = createStytchB2BHeadlessClient(publicToken)
//       } catch (error) {
//         console.error('Failed to create Stytch client:', error)
//       }
//     }
//   }
//   return stytchClient
// }
// /**
//  * Reset the Stytch client (useful for testing)
//  */
// export function resetStytchClient() {
//   stytchClient = null
// }
/**
 * Stytch Headless Client Management
 * Ensures a single B2B headless client per tab and avoids SSR issues/HMR re-inits.
 */
import { createStytchB2BHeadlessClient } from '@stytch/nextjs/b2b/headless';
// Create/get a single client instance on the browser.
// Do NOT call on the server. Always safe to call in client components/hooks.
export function getStytchClient() {
    if (typeof window === 'undefined')
        return null;
    if (window.__stytchB2B)
        return window.__stytchB2B;
    const publicToken = process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN;
    if (!publicToken) {
        // Helpful during local dev if the token isn't set or env mismatch
        console.error('Stytch: NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN is missing. ' +
            'Check your .env.local and that it is prefixed with NEXT_PUBLIC_.');
        return null;
    }
    try {
        // Configure the headless client with the same cookie options as the provider
        const stytchOptions = {
            cookieOptions: {
                opaqueTokenCookieName: 'stytch_session',
                jwtCookieName: 'stytch_session_jwt',
                path: '/',
                availableToSubdomains: false,
                domain: undefined,
                maxAge: 5400000, // 90,000 minutes in seconds
                sameSite: 'lax',
                secure: process.env.NODE_ENV === 'production',
            },
        };
        window.__stytchB2B = createStytchB2BHeadlessClient(publicToken, stytchOptions);
        return window.__stytchB2B;
    }
    catch (err) {
        console.error('Stytch: failed to create B2B headless client:', err);
        window.__stytchB2B = null;
        return null;
    }
}
// Useful for tests or explicit teardown flows
export function resetStytchClient() {
    if (typeof window !== 'undefined') {
        window.__stytchB2B = null;
    }
}
